import React, { useEffect, useState } from "react";
import { Text, StyleSheet, Platform } from "react-native";
import { findIndex } from "lodash";
import { sortBy } from "../../../../../helpers/utils";

import AppTheme from "../../../AppTheme";
import ReflectionHelper from "../../../reflection/ReflectionHelper";

export default function ComparisonSentence({
  data,
  selectedDate,
  timeUnit = "week",
}) {
  const [text, setText] = useState("");

  useEffect(() => {
    if (!selectedDate || !data?.reflection_hours) return;

    let rh = data.reflection_hours;
    if (!rh[selectedDate]) rh[selectedDate] = {};

    const allDays = sortBy(Object.keys(rh));
    const currentDayIndex = findIndex(allDays, (d) => d == selectedDate);
    if (currentDayIndex < 0) return;

    const todayH = rh[selectedDate].hours || 0;
    let prevH = 0;
    if (currentDayIndex > 0) {
      const prevDate = allDays[currentDayIndex - 1];
      if (prevDate) prevH = rh[prevDate].hours || 0;
    }

    const diffOperatorText = ReflectionHelper.getOperatorText(todayH - prevH);

    const averageH = data.averages?.recent || 0;
    const averageOpText = ReflectionHelper.getOperatorText(todayH - averageH);

    setText(
      `You spent ${diffOperatorText} the ${timeUnit} before & ${averageOpText} your recent average.`,
    );
  }, [selectedDate, timeUnit]);

  return !text ? null : (
    <Text style={styles.infoText} numberOfLines={3}>
      {text}
    </Text>
  );
}

const styles = StyleSheet.create({
  infoText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    flex: 1,
    marginRight: 16,
  },
});
